import { Route, Routes } from "react-router-dom";
import CarreraGovTech from "../newPages/carreras/CarreraGovTech";
import CarreraGovTechMetodologia from "../newPages/carreras/CarreraGovTechMetologia";
import CarreraEnergia from "../newPages/carreras/CarreraEnergia";
import CarreraRiesgos from "../newPages/carreras/CarreraRiesgos";
import CarreraRecursosNaturales from "../newPages/carreras/CarreraRecursosNaturales";
import CarreraTurismoGastronomia from "../newPages/carreras/CarreraTurismoGastronomia";
import CarreraNegociosMetodologia from "../newPages/carreras/CarreraNegociosMetodologia";

function RoutesCarreras() {
  return (
    <>
      <Routes>
        {" "}
        <Route
          path="/carrera-govtech-online"
          element={<CarreraGovTech></CarreraGovTech>}
        />
         <Route
          path="/metodologia-govtech"
          element={<CarreraGovTechMetodologia></CarreraGovTechMetodologia>}
        />
         <Route
          path="/carrera-energia-online"
          element={<CarreraEnergia></CarreraEnergia>}
        /> 

         <Route
          path="/carrera-riesgos-online"
          element={<CarreraRiesgos></CarreraRiesgos>}
        /> 

        
         <Route
          path="/carrera-recursos-naturales"
          element={<CarreraRecursosNaturales></CarreraRecursosNaturales>}
        /> 
          <Route
          path="/carrera-turismo-gastronomia"
          element={<CarreraTurismoGastronomia></CarreraTurismoGastronomia>}
        /> 
         <Route
          path="/metodologia-turismo-gastromonia"
          element={<CarreraNegociosMetodologia></CarreraNegociosMetodologia>}
        />
      </Routes>{" "}
    </>
  );
}

export default RoutesCarreras;
